import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ProgressStates } from './progress-states.model';
import { FiltersComponent } from '../dashboard/filters/filters.component';

@Component({
  selector: 'ssg-at-a-glance',
  templateUrl: './at-a-glance.component.html',
  styleUrls: ['./at-a-glance.component.less']
})
export class AtAGlanceComponent {
  @ViewChild(FiltersComponent, { static: false }) filtersControl: FiltersComponent;

  progressStates = new Map<string, ProgressStates>();

  allExpanded: boolean;

  constructor(private _changeDetector: ChangeDetectorRef) {
    this.progressStates.set('payroll', new ProgressStates());
    this.progressStates.set('collections', new ProgressStates());
    this.progressStates.set('payment', new ProgressStates());
  }

  updateProgressStates(key: string, states: ProgressStates) {
    this.progressStates.set(key, states);
    this._changeDetector.detectChanges();
  }
}
